import { Alignments, Positions, Placement } from './types';

export const placements = {
  AUTO: 'auto',
  AUTO_START: 'auto-start',
  AUTO_END: 'auto-end',
  TOP: 'top-center',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM: 'bottom-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  LEFT: 'left-middle',
  LEFT_TOP: 'left-top',
  LEFT_BOTTOM: 'left-bottom',
  RIGHT: 'right-middle',
  RIGHT_TOP: 'right-top',
  RIGHT_BOTTOM: 'right-bottom'
};

export const placementMap = {
  'auto-start': placements.AUTO,
  'auto-end': placements.AUTO_END,
  auto: placements.AUTO,
  top: placements.TOP,
  'top-start': placements.TOP_LEFT,
  'top-end': placements.TOP_RIGHT,
  bottom: placements.BOTTOM,
  'bottom-start': placements.BOTTOM_LEFT,
  'bottom-end': placements.BOTTOM_RIGHT,
  left: placements.LEFT,
  'left-start': placements.LEFT_TOP,
  'left-end': placements.LEFT_BOTTOM,
  right: placements.RIGHT,
  'right-start': placements.RIGHT_TOP,
  'right-end': placements.RIGHT_BOTTOM
};

/** Translate position and alignment props to Popper placement */
export const getPlacementKey = (
  alignment: Alignments,
  position: Positions
): Placement => {
  let placement: Placement;

  switch (alignment) {
    case 'left':
    case 'top':
      placement = `${position}-start` as Placement;
      break;
    case 'right':
    case 'bottom':
      placement = `${position}-end` as Placement;
      break;
    default:
      placement = position;
      break;
  }

  return placement;
};

/** given alignment and position, returns the proper placement */
export const getPlacement = (alignment: Alignments, position: Positions) =>
  placementMap[getPlacementKey(alignment, position)];
